import Vue from 'vue';
import Main from './index.vue';
let MessageConstructor = Vue.extend(Main);
let instance;
const demo = function(opt) {
    if (document.getElementsByClassName('warning-box').length) {
        return;
    }
    let options = opt || {};
    if (typeof options === 'string') {
        options = {
            'message': options
        };
    }
    (!options.confirm) && (options.confirm = () => {});
    instance = new MessageConstructor({
        'data': options
    });
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
    instance.vm.visible = true;
    instance.dom = instance.vm.$el;
    return instance.vm;
};
export default demo;
